import { render, staticRenderFns } from "./forgetNumber.vue?vue&type=template&id=0813e658&scoped=true"
import script from "./forgetNumber.vue?vue&type=script&lang=js"
export * from "./forgetNumber.vue?vue&type=script&lang=js"
import style0 from "./forgetNumber.vue?vue&type=style&index=0&id=0813e658&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0813e658",
  null
  
)

export default component.exports